<template>
  <div>
    <table-list ref="table" idKey="orderId" :listConfig="listConfig" :searchConfig="searchConfig"
                :apis="apis" :createFrom="fromConfig" :btn-config="btnConfig"
                @handleBtn="handleBtn" @cellDblclick="cellDblclick"
                :btnConfig="btnConfig | filterBtnsRole($route)">
    </table-list>
    <from-list ref="reject" :fromConfig="rejectConfig" @confirm="rejectConfirm"/>
    <detail-list ref="detail" :detailConfig="detailConfig" :detailApi="apis.detail">
      <div style="padding: 0 104px;" slot="box_operation_record" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="operation" label="操作"/>
          <el-table-column header-align="center" align="center" prop="operationTime" label="操作时间"/>
          <el-table-column header-align="center" align="center" prop="operatorName" label="操作人"/>
          <el-table-column header-align="center" align="center" prop="money" label="结算金额"/>
        </el-table>
      </div>
      <div style="padding: 0 104px;" slot="box_operation_remark" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="date" label="时间"/>
          <el-table-column header-align="center" align="center" prop="operatorName" label="备注人"/>
          <el-table-column header-align="center" align="center" prop="remark" label="备注内容"/>
        </el-table>
      </div>
    </detail-list>
  </div>
</template>

<script>
import config from './config/ysaudit'
import {openMessageBox} from '@/utils'

export default {
  data() {
    return {
      roadList: [],
      searchConfig: [],
      rejectConfig: [],
      ...config()
    }
  },
  created() {
    this.createConfig()
  },
  methods: {
    createConfig() {
      this.searchConfig = this.createSearch();
    },
    cellDblclick(row) {
      this.$refs.detail.getDtail(row.orderId);
    },
    handleBtn(key, list) {
      if (key === 'submit') {
        if (list.length < 1) this.$error('请选择一项操作');
        this.paymentConfirm(list.map(x => x.orderId))
      } else if (key === 'reject') {
        if (list.length < 1) this.$error('请选择一项操作');
        this.rejectConfig = this.createReject();
        this.$refs[key].open(null, {ids: list.map(x => x.orderId)})
      }else if (key === 'export') {
        console.log('export')
        if (list.length < 1) this.$error('请至少选择一项导出')
      }
    },
    paymentConfirm(ids) {
      openMessageBox({
        content: '是否确认结算？'
      }, async boolean => {
        if (boolean) {
          const [res] = await this.$ajax(this.apis.submit, {ids: ids});
          res && this.$refs.table.getList();
        }
      })
    },
    async rejectConfirm(data) {
      const params = this.$params(this.rejectConfig);
      const [res] = await this.$ajax(this.apis.reject, {...params, ...data});
      if (res) {
        this.$refs.reject.close();
        this.$refs.table.getList();
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
